import { initAboutCompanyMission } from './about-company-mission.js';
import { initAboutCompanyTeam } from './about-company-team.js';
import { initAdvantagesPageSliderSection } from './advantages-page-slider-section.js';
import { initSliderHomePageInHeaderHero } from './home-page-in-header-hero.js';
import { initSliderHomePagePlatformControl } from './home-page-platform-control.js';

/**
 * Справочник по настройкам Swiper:
 *
 * https://swiperjs.com/
 *
 * loop:
 * - true: бесконечный слайдер, создаёт клоны слайдов и крутится по кругу.
 *
 * loopAdditionalSlides:
 * - Увеличивает количество loop-слайдов, чтобы карусель одинаково работала вперёд и назад.
 *
 * speed:
 * - Длительность анимации переключения в миллисекундах.
 *
 * slidesPerGroup:
 * - Количество слайдов, на которое слайдер двигается за одно действие.
 *
 * slidesPerView:
 * - 'auto': ширина карточки берётся из CSS, а видимая область ограничивается шириной слайдера.
 *
 */

export const initSliders = () => {
    initAboutCompanyMission();
    initAboutCompanyTeam();
    initAdvantagesPageSliderSection();
    initSliderHomePageInHeaderHero();
    initSliderHomePagePlatformControl();
};
